import { render } from "./modal-task.vue?vue&type=template&id=c8d8725a&scoped=true"
import script from "./modal-task.vue?vue&type=script&lang=js"
export * from "./modal-task.vue?vue&type=script&lang=js"

import "./modal-task.vue?vue&type=style&index=0&id=c8d8725a&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d8725a"]])

export default __exports__